/* eslint-disable jsx-a11y/no-static-element-interactions */
/*eslint-disable no-useless-concat*/
import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Row } from 'react-bootstrap';
import './flipcard.scss';
import { getBackCardStyle, getBorderStyle, getFrontCardStyle } from '../../../middleware/getStyle';

// Browsers start playing a native `autoplay` <audio> the instant it mounts,
// before the pause-on-mount effect below can run, so the back-card audio is
// briefly audible even though the front is showing. Swap `autoplay` for a
// data attribute and trigger playback ourselves once the correct side is known.
const neutralizeAudioAutoplay = (html: string) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  wrapper.querySelectorAll('audio[autoplay]').forEach((audio) => {
    audio.removeAttribute('autoplay');
    audio.setAttribute('data-autoplay', 'true');
  });
  return wrapper.innerHTML;
};

export const noOfCardsValues = (noofcard: string) => {
  switch (true) {
    case noofcard === '4':
      return '3';
    case noofcard === '3':
      return '4';
    case noofcard === '2':
      return '6';
    case noofcard === '1':
      return '7';
    default:
      return '3';
  }
};

export const FlipcardComponent = (props: any) => {
  const { customisations, type, parameters } = props;
  const noofcard = customisations.noOfCard === '' ? 4 : customisations.noOfCard;
  const noOfCards = noOfCardsValues(noofcard);
  const borderStyle = getBorderStyle(customisations);
  const frontCardStyle = getFrontCardStyle(customisations);
  const backCardStyle = getBackCardStyle(customisations);
  const cardType = customisations.cardType ?? 'square';
  const frontHeight = customisations.frontHeight ? customisations.frontHeight + 'px' : '318px';
  const backHeight = customisations.backHeight ? customisations.backHeight + 'px' : '318px';
  const isSquare = cardType !== 'portrait' ? 'h-100' : '';
  const orientation =
    type === 'view' ? `${cardType}-card-${noOfCards}` : `${type}-${cardType}-card-${noOfCards}`;

  const frontHeader = customisations.frontHeader !== '' ? customisations.frontHeader : 'div';
  const backHeader = customisations.backHeader !== '' ? customisations.backHeader : 'div';

  const toggleCardAudio = (idx: number, isFlipped: boolean) => {
    const activeCard = document.getElementById(isFlipped ? `back_${idx}` : `front_${idx}`);
    const inactiveCard = document.getElementById(isFlipped ? `front_${idx}` : `back_${idx}`);
    inactiveCard?.querySelectorAll<HTMLAudioElement>('audio').forEach((audio) => audio.pause());
    activeCard
      ?.querySelectorAll<HTMLAudioElement>('audio[data-autoplay="true"]')
      .forEach((audio) => {
        audio.currentTime = 0;
        audio.play().catch(() => {});
      });
  };

  useEffect(() => {
    // Every card starts on its front side, so only start autoplay audio
    // that lives on the front; the back stays silent until it's flipped to.
    parameters.forEach((_content: unknown, idx: number) => {
      document
        .getElementById(`front_${idx}`)
        ?.querySelectorAll<HTMLAudioElement>('audio[data-autoplay="true"]')
        .forEach((audio) => audio.play().catch(() => {}));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const flip = (idx: number) => {
    const element = document.getElementById(`flip_${idx}`);
    const parentElement = document.getElementById(`flipcard_${idx}`);
    element?.classList.toggle('flipped');
    handleKeyBoardEvents(idx, element);
    const isFlipped = !!element?.classList.contains('flipped');
    const heightValue = isFlipped ? backHeight : frontHeight;
    if (cardType !== 'square') {
      parentElement?.style.setProperty('height', heightValue);
    }
    toggleCardAudio(idx, isFlipped);
  };

  const handleKeyBoardEvents = (idx: number, element: HTMLElement | null) => {
    const frontCard = document.getElementById(`front_${idx}`);
    const backCard = document.getElementById(`back_${idx}`);
    if (element?.classList.contains('flipped')) {
      backCard?.removeAttribute('aria-hidden');
      frontCard?.removeAttribute('aria-live');
      backCard?.setAttribute('aria-live', 'polite');
      frontCard?.setAttribute('aria-hidden', 'true');
    } else {
      frontCard?.removeAttribute('aria-hidden');
      frontCard?.setAttribute('aria-live', 'polite');
      backCard?.removeAttribute('aria-live');
      backCard?.setAttribute('aria-hidden', 'true');
    }
  };

  const handleMouseOver = (idx: number) => {
    const element = document.getElementById(`flip_${idx}`);
    if (!element?.classList.contains('flipped')) return;
    element?.classList.toggle('flipped');
    toggleCardAudio(idx, false);
  };

  const keyUpEvent = (idx: number, event: { key: string }) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    flip(idx);
  };
  return (
    <Row
      className={noOfCards === '7' ? 'm-2 justify-content-center' : 'mx-2'}
      tabIndex={0}
      aria-label='Flipcard'
    >
      {parameters.map((content: { [x: string]: string }, idx: number) => (
        <div
          className={`p-2 flip col-sm-${noOfCards} ${
            customisations.cardType === 'square' ? '' : orientation
          } ${customisations.flip === '1' ? 'rotate' : ''}`}
          key={content['fronttext']}
          id={`flipcard_${idx}`}
          style={cardType !== 'square' ? { height: frontHeight } : {}}
        >
          <div
            id={`flip_${idx}`}
            className={`responsiveCard inner ${customisations.radius}`}
            onClick={
              customisations.flip === '1'
                ? () => {}
                : () => {
                    flip(idx);
                  }
            }
            onKeyUp={(event) => keyUpEvent(idx, event)}
          >
            <div
              className={`shadow front ${isSquare}`}
              id={`front_${idx}`}
              role='button'
              style={{
                ...borderStyle,
                ...frontCardStyle,
              }}
              tabIndex={0}
            >
              <Row bsPrefix='flipcardRow' id={`frontCard_${idx}`} as={frontHeader}>
                {ReactHtmlParser(neutralizeAudioAutoplay(content['fronttext']))}
              </Row>
            </div>
            <div
              className={`shadow back ${isSquare}`}
              id={`back_${idx}`}
              aria-hidden='true'
              role='button'
              style={{
                ...borderStyle,
                ...backCardStyle,
              }}
              onMouseOver={customisations.flip === '1' ? () => handleMouseOver(idx) : () => {}}
              onFocus={customisations.flip === '1' ? () => handleMouseOver(idx) : () => {}}
            >
              <Row bsPrefix='flipcardRow' id={`backCard_${idx}`} as={backHeader}>
                {ReactHtmlParser(neutralizeAudioAutoplay(content['backtext']))}
              </Row>
            </div>
          </div>
        </div>
      ))}
    </Row>
  );
};
